module.exports = __webpack_public_path__ + "img/读卡一体机 (5).1841875c.jpg";